export enum AuthenticationActionType {
    SET_AUTH_INFO = "AUTH/SET_AUTH_INFO",
}

export const ENV_CONFIG = (process as any).env.config || {DOMAIN: "", AUDIENCE: "", CLIENT_ID: ""};
export const {DOMAIN, AUDIENCE, CLIENT_ID} = ENV_CONFIG;

